import { ANDROID_STORE_TRACK_URL, APPLE_STORE_TRACK_URL } from "@/common";
import { getUri } from "./url";
import { fetchTrackingRecordSave } from "@/api/track";
import {
  CustomerAttributionFieldMap,
  TrackingBtnId,
  TrackingEventID,
  TrackingEventPageID,
  TrackingEventType,
  TrackingFieldMap,
} from "@/shared";
import { getUriQuery } from "./url";
import { isAndroid } from "./is";
import { clientWindow } from "./dom";

/**
 * 根据映射关系从URL查询参数中提取并转换字段
 * @param str url字符串或search部分
 * @param fieldMap 字段映射关系，键为URL参数名，值为目标字段名数组
 * @returns 返回转换后的对象
 */
export const getCustomerAttributionFromUri = (
  str: string,
  fieldMap: { [key: string]: string[] }
): Record<string, string> => {
  const result: Record<string, string> = {};
  const searchParams = new URLSearchParams(str);
  Object.entries(fieldMap).forEach(([urlParam, targetFields]) => {
    const value = searchParams.get(urlParam);
    if (value !== null) {
      targetFields.forEach((targetField) => {
        result[targetField] = value;
      });
    }
  });
  return result;
};

/**
 * 获取带有客户归因参数的Tenjin追踪链接
 * @param urlStr 当前页面URL字符串或search部分
 * @returns 包含归因参数的Tenjin追踪链接
 */
export const getTenjinTrackUrlWithAttribution = (
  deepLinkUrl?: string
): string => {
  const urlStr = clientWindow?.location?.search || "";
  const baseTrackUrl = isAndroid()
    ? ANDROID_STORE_TRACK_URL
    : APPLE_STORE_TRACK_URL;
  const attributionParams = getCustomerAttributionFromUri(
    urlStr,
    CustomerAttributionFieldMap
  );

  if (deepLinkUrl) {
    attributionParams.deeplink_url = deepLinkUrl;
  }
  if (!attributionParams["channel_referrer"]) {
    attributionParams["tenjin_parameter_3"] = encodeURIComponent(location.href);
  }
  return getUri(baseTrackUrl, attributionParams);
};

/**
 * 构建归因事件数据
 * @param query URL查询参数对象
 * @returns 构建后的跟踪数据
 */
export function buildTrackingEventData(
  query: Record<string, string>
): Record<string, Record<string, string> | string> {
  const trackingData: Record<string, Record<string, string> | string> = {};
  for (const key of Object.keys(TrackingFieldMap)) {
    const fn = TrackingFieldMap[key];
    if (fn) {
      trackingData[key] = fn(query);
    }
  }
  return trackingData;
}

/**
 * 跳转到应用商店（通过Tenjin追踪链接）
 * @param urlParams URL参数字符串或完整URL
 * @param deepLinkUrl 可选的深度链接URL
 */
export const jumpToAppStore = (deepLinkUrl?: string): void => {
  const urlStr = clientWindow?.location?.search || "";
  const queryData = getUriQuery(urlStr);
  const trackingData = buildTrackingEventData(queryData);
  fetchTrackingRecordSave({
    event_id: TrackingEventID.Download,
    event_type: TrackingEventType.Click,
    page_id: TrackingEventPageID.DownloadPage,
    btn_id: TrackingBtnId.DownloadBtn,
    ...trackingData,
  });
  const trackUrl = getTenjinTrackUrlWithAttribution(deepLinkUrl);
  const a = document.createElement("a");
  a.href = trackUrl;
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
